class Analysis {
	constructor(instance) {
		this.axios = instance;
	}
	//분석 리스트
	async getList(params) {
		try {
			const response = await this.axios.get(`/test/list`, {params})
	
			return response.data;
		} catch(e) {
			return false;
		}
	}
	/** @param {string|string[]} types - category 코드(SOIL, WATER, …) 단일 또는 복수(합집합) */
	async getFilterCategoryList(types) {
		try {
			const arr = Array.isArray(types) ? types : [types]
			const unique = [...new Set(arr.filter(Boolean))]
			const typeParam =
				unique.length > 0 ? unique.join(',') : 'SOIL'
			const response = await this.axios.get(`/test/filter/list`, {
				params: { type: typeParam }
			})

			return response.data;
		} catch(e) {
			return false;
		}
	}
}

export default Analysis